import { type AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import {
  type IParamsAnalyticsSurveyContacts,
  type IResponseAnalyticsSurvey,
  type IResponseAnalyticsSurveyContacts,
} from 'entities/Analytics/api/types'
import { baseApi } from 'entities/Auth'

class SurveysApi {
  getAnalyticsSurveyById(
    id: number,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseAnalyticsSurvey>> {
    return baseApi.get(`analytics/analytics/surveys/${id}`, { ...options })
  }

  getAnalyticsSurveyByIdExecutions(
    id: number,
    params: IParamsAnalyticsSurveyContacts,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseAnalyticsSurveyContacts>> {
    return baseApi.get(`analytics/analytics/surveys/${id}/executions`, {
      ...options,
      params: params,
    })
  }
}

export const SurveysAnalyticsApi = new SurveysApi()
